/* Native details provides tap/keyboard access even without JavaScript. */
if (!customElements.get('sunco-made-to-order')) {
  customElements.define('sunco-made-to-order', class extends HTMLElement {
    connectedCallback() {
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      if (!details || !summary) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      let pinned = false;
      const close = () => {
        pinned = false;
        details.open = false;
      };
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') details.open = true;
      }, options);
      this.addEventListener('pointerleave', () => {
        if (!pinned) details.open = false;
      }, options);
      summary.addEventListener('click', () => {
        // Native details performs the toggle after this listener.
        pinned = !details.open;
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) close();
      }, options);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) close();
      }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
